import { render, staticRenderFns } from "./StepsLineComponent.vue?vue&type=template&id=c87b5ab2&scoped=true&"
import script from "./StepsLineComponent.vue?vue&type=script&lang=js&"
export * from "./StepsLineComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepsLineComponent.vue?vue&type=style&index=0&id=c87b5ab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b5ab2",
  null
  
)

export default component.exports